import cloneDeep from "clone-deep";
import { getTime, setHours, setMinutes } from "date-fns";
import { useCallback, useContext, useEffect, useMemo, useRef, useState } from "react";
import { useBoolean } from "usehooks-ts";
import contextBabylon from "../../../../../../../../../context/index.js";
import { formatDate } from "../../../../../../../../../helpers/date.js";
const useCalendarMobileTimeModal = (props)=>{
    const { value , onChange , enableTime =false , mode , minTime ='00:00' , maxTime ='23:59'  } = props;
    const { Language  } = useContext(contextBabylon);
    const { value: isTimeVisible , setTrue: showTime , setFalse: hideTime  } = useBoolean(false);
    const lastValue = useRef(value);
    const [selectedDateIndex, setSelectedDateIndex] = useState(value.length - 1);
    useEffect(()=>{
        if (!enableTime) return;
        if (lastValue.current !== value) {
            if (getTime(lastValue.current[0]) !== getTime(value[0])) {
                setSelectedDateIndex(0);
            } else if (value?.length > 1 && getTime(lastValue.current[1]) !== getTime(value[1])) {
                setSelectedDateIndex(1);
            }
            lastValue.current = value;
            showTime();
        }
    }, [
        enableTime,
        showTime,
        value
    ]);
    const [timeString, setTimeString] = useState('');
    useEffect(()=>{
        if (!enableTime) return;
        formatDate(value[selectedDateIndex], "EEE, d MMM uuuu - HH:mm'h'", Language).then(setTimeString).catch(console.error);
    }, [
        Language,
        enableTime,
        selectedDateIndex,
        value
    ]);
    useEffect(()=>{
        if (!enableTime) return;
        if (!isTimeVisible) setTimeString('');
    }, [
        enableTime,
        isTimeVisible
    ]);
    const times = useMemo(()=>{
        let times = [];
        for(let i = 0; i < 24; i++){
            const hours = String(i).padStart(2, '0');
            const oClock = `${hours}:00`;
            const halfPast = `${hours}:30`;
            if (oClock >= minTime && oClock <= maxTime) {
                times.push({
                    label: oClock,
                    value: oClock
                });
            }
            if (halfPast >= minTime && halfPast <= maxTime) {
                times.push({
                    label: halfPast,
                    value: halfPast
                });
            }
        }
        return times;
    }, [
        maxTime,
        minTime
    ]);
    const timeValue = useMemo(()=>{
        const date = value[selectedDateIndex] || value[0];
        if (!date) return times[0];
        const hours = date.getHours();
        const minutes = date.getMinutes();
        const roundedMinutes = Math.round(minutes / 30);
        const finalMinutes = roundedMinutes === 2 || roundedMinutes === 0 ? '00' : '30';
        let finalHours = String(roundedMinutes === 2 ? hours + 1 : hours);
        if (finalHours === '24') {
            finalHours = '00';
        }
        const finalTime = `${finalHours.padStart(2, '0')}:${finalMinutes.padStart(2, '0')}`;
        return times.find((time)=>time.value === finalTime);
    }, [
        selectedDateIndex,
        times,
        value
    ]);
    const handleOnTimeChange = useCallback((newValue)=>{
        if (Array.isArray(newValue)) return;
        const typedNewValue = newValue;
        if (typeof typedNewValue?.value !== 'string' || !onChange) return;
        const [hours, minutes] = typedNewValue.value.split(':');
        const newDates = cloneDeep(value);
        newDates[selectedDateIndex] = setHours(newDates[selectedDateIndex], Number(hours));
        newDates[selectedDateIndex] = setMinutes(newDates[selectedDateIndex], Number(minutes));
        // @ts-ignore
        onChange(newDates);
    }, [
        onChange,
        selectedDateIndex,
        value
    ]);
    const onConfirm = useCallback((hide)=>()=>{
            if (mode === 'single') hide();
            if (mode === 'range' && value.length === 2) hide();
            hideTime();
        }, [
        hideTime,
        mode,
        value.length
    ]);
    return {
        times,
        timeString,
        timeValue,
        handleOnTimeChange,
        isTimeVisible,
        showTime,
        hideTime,
        onConfirm
    };
};
export default useCalendarMobileTimeModal;

//# sourceMappingURL=useCalendarMobileTimeModal.js.map